// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapMarker__marker-e09f39 {
  width: 26px;
  height: 40px;
  margin: -40px 0 0 -13px;
}`, "",{"version":3,"sources":["webpack://./src/components/MapMarker/MapMarker.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AACF","sourcesContent":[".marker {\n  width: 26px;\n  height: 40px;\n  margin: -40px 0 0 -13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marker": `MapMarker__marker-e09f39`
};
module.exports = ___CSS_LOADER_EXPORT___;
